import { useTranslation } from '@mint-lib/i18n';
import { Export } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';
import { ProgressCircular } from '@mint-lib/tw-components/patterns';
import { getRouteApi } from '@mint/routing';

import { useExportMediaPlan } from '../../../../../../api/mutations/useExportMediaPlan.js';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const ExportPlanBtn = () => {
  const { t } = useTranslation('@myn/planning_v2');

  const { campaignId: mediaPlanId } = routerApi.useParams();

  const { mutate: exportMediaPlan, isPending } = useExportMediaPlan();

  const handleExport = async () => {
    exportMediaPlan(mediaPlanId);
  };

  return (
    <Button
      variant="text"
      size="medium"
      aria-label="Export current plan"
      data-dd-action-name="Planning header: export plan"
      onClick={handleExport}
      disabled={isPending}
    >
      {isPending ? <ProgressCircular size="xsmall" /> : <Export />}
      {t('Export current plan')}
    </Button>
  );
};
